import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../lib/adminApi';
import { stripeMrr, type StripeSubRow } from '../lib/money';

/**
 * Current MRR straight from Stripe (admin-api stripe_overview), per currency.
 * The deployed action returns one page of up to 100 subscriptions of any status;
 * when it returns 100 the result may be missing older active subscriptions, and the
 * page says so instead of presenting a partial total as complete.
 */
export function useStripeMrr() {
  return useQuery({
    queryKey: ['stripe_overview'],
    queryFn: async () => {
      const res = await adminApi<{ subscriptions?: StripeSubRow[]; has_more?: boolean }>('stripe_overview');
      const rows = Array.isArray(res.subscriptions) ? res.subscriptions : [];
      return { rows, mrr: stripeMrr(rows, res.has_more), readAt: new Date().toISOString() };
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}
